export const IDS = {
  // Auth
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  loginGoogle: "auth-login-google",
  registerLink: "auth-register-link",
  logoutBtn: "topbar-logout",

  // Shell
  sidebar: "app-sidebar",
  sidebarNav: (key) => `sidebar-nav-${key}`,
  themeToggle: "topbar-theme-toggle",
  userAvatar: "topbar-user-avatar",
  globalSearch: "topbar-global-search",

  // Dashboard
  kpiIdentities: "kpi-identities",
  kpiLocked: "kpi-locked",
  kpiPending: "kpi-pending",
  kpiAudit24h: "kpi-audit-24h",
  chartTimeseries: "chart-timeseries",
  chartRisk: "chart-risk",

  // Identities
  identitySearch: "identity-search-input",
  identityRow: (id) => `identity-row-${id}`,
  identityLockBtn: (id) => `identity-lock-${id}`,
  identityUnlockBtn: (id) => `identity-unlock-${id}`,
  lockDialog: "lock-dialog",
  lockReasonInput: "lock-reason-input",
  lockTierSelect: "lock-tier-select",
  lockSubmit: "lock-submit",
  unlockDialog: "unlock-dialog",
  unlockReasonInput: "unlock-reason-input",
  unlockSubmit: "unlock-submit",

  // Approval queue
  approvalRow: (id) => `approval-row-${id}`,
  approvalApprove: (id) => `approval-approve-${id}`,
  approvalReject: (id) => `approval-reject-${id}`,

  // Recovery
  recoveryNew: "recovery-new",
  recoverySubmit: "recovery-submit",
  recoveryVlkInput: "recovery-vlk-input",
  recoveryEmailInput: "recovery-email-input",
  recoveryReasonInput: "recovery-reason-input",
  recoveryStateFilter: "recovery-state-filter",
  recoveryKpiInflight: "recovery-kpi-inflight",
  recoveryOpen: (id) => `recovery-open-${id}`,
  recoveryBack: "recovery-back",
  recoveryAttestBtn: "recovery-attest-btn",
  recoveryAttestSubmit: "recovery-attest-submit",
  recoveryAttestNote: "recovery-attest-note",
  recoveryInstSelect: "recovery-inst-select",
  recoveryApproveBtn: "recovery-approve-btn",
  recoveryRejectBtn: "recovery-reject-btn",
  recoveryDecisionSubmit: "recovery-decision-submit",
  recoveryDecisionNote: "recovery-decision-note",
  recoveryReactivateBtn: "recovery-reactivate-btn",
  recoveryReactivateSubmit: "recovery-reactivate-submit",
  recoveryEvidenceBtn: "recovery-evidence-btn",
  recoveryEvidenceSubmit: "recovery-evidence-submit",
  recoveryEvidenceKind: "recovery-evidence-kind",
  recoveryEvidenceDesc: "recovery-evidence-desc",
  identityInitiateRecovery: "identity-initiate-recovery",

  // Audit
  auditExport: "audit-export",
  auditRow: (id) => `audit-row-${id}`,

  // Live audit / operations console
  liveAuditPage: "live-audit-page",
  liveOpsConsole: "live-ops-console",
  liveOpsHandle: "live-ops-handle",
  liveOpsPause: "live-ops-pause",
  liveOpsResume: "live-ops-resume",
  liveOpsExpand: "live-ops-expand",
  liveAuditRow: (id) => `live-audit-row-${id}`,

  // QR
  qrGenerateBtn: "qr-generate",
  qrCanvas: "qr-canvas",
  qrVerifyInput: "qr-verify-input",
  qrVerifyBtn: "qr-verify-btn",

  // Notifications
  notifBell: "topbar-notifications",
  notifItem: (id) => `notif-${id}`,
};
